Aquí tienes el componente completo. Se ha añadido un **degradado oscuro inferior (*gradient overlay*)** que garantiza la lectura perfecta de las letras blancas y una **animación de revelado elegante con GSAP** para la firma (efecto de aparición suave con ligera rotación y elevación al entrar en la pantalla).

```vue
<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="image"
      src="@/assets/IMG_0775_11zon.webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >
    
    <!-- 🔥 SOMBRA INFERIOR PARA LECTURA PERFECTA -->
    <div class="dark-overlay"></div>
    
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        With love,<br>
        <span>Juliett Garcia </span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const imageContainer = ref(null)

    onMounted(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: imageContainer.value,
          start: 'top 80%', // Se activa en cuanto entra al viewport
          once: true
        }
      })

      /* 🖼️ ANIMACIÓN DE LA IMAGEN CON REVELADO DRAMÁTICO */
      tl.fromTo(
        image.value,
        {
          opacity: 0,
          scale: 1.3,
          y: 50
        },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 1.8,
          ease: 'power3.out'
        }
      )

      /* ✨ ANIMACIÓN PADRÍSIMA PARA LA FIRMA (Efecto flotante elegante) */
      .fromTo(
        textRef.value,
        {
          opacity: 0,
          y: 40,
          scale: 0.9,
          rotationX: -15
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          rotationX: 0,
          duration: 1.2,
          ease: 'back.out(1.4)'
        },
        '-=0.8' // Empieza antes de que termine la imagen para mayor fluidez
      )
    })

    return { textRef, image, imageContainer }
  }
}
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 600px;
  overflow: hidden;
  position: relative;
  display: flex;
  
  align-items: center;
  justify-content: center;
  perspective: 1000px; /* Habilita el efecto 3D sutil para la firma */
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(90%);
}

/* 🔥 DEGRADADO OSCURO INFERIOR SUAVE Y ELEGANTE */
.dark-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%; /* Cubre la mitad inferior de la imagen */
 
  z-index: 2;
  pointer-events: none;
}

.text-overlay {
  position: absolute;
  bottom: 30px;
  width: 100%;
  text-align: center;
  color: #ffffff;
  z-index: 10;
  padding: 0 20px;
  /* Sombra de texto suave para asegurar contraste máximo */
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.firma {
  font-size: 18px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 2px;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: 10px !important;
  font-family: 'FeelingPassionate', cursive;
  font-size: 2rem;
  letter-spacing: 1px;
}
</style>

```